<template>
	<div ref="nav">
		<div
			class="nav"
			:class="{
				withImage: withImage,
				transparent: transparent,
				scrolled: scrolled,
				'nav-invert': invert,
			}"
		>
			<nav class="navbar">
				<div class="container">
					<div class="row">
						<div class="col-12 header">
							<div class="">
								<div class="">
									<div class="d-flex align-items-center justify-content-between">
										<router-link tag="a" :to="`/`">
											<img src="@/assets/logo.png" alt="" class="logo logo-light" />
											<img src="@/assets/logo-dark.png" alt="" class="logo logo-dark" />
										</router-link>

										<div class="only-desktop" v-if="!hideMenu">
											<b-nav>
												<b-nav-item :to="`/`" active>Inicio </b-nav-item>
												<b-nav-item :to="`/campers`">Campers</b-nav-item>
												<b-nav-item :to="`/productos`">Accesorios</b-nav-item>
												<b-nav-item :to="`/quienes-somos`">Quienes somos</b-nav-item>
												<b-nav-item :to="`/preguntas-frecuentes`">Preguntas frecuentes</b-nav-item>
												<b-nav-item :to="`/contacto`">Contacto </b-nav-item>
												<b-nav-item :to="`/checkout`" v-if="!hideCart">
													<CartNavbar :invert="scrolled || invert" />
												</b-nav-item>
											</b-nav>
										</div>

										<div class="only-mobile" v-if="!hideMenu">
											<div class="d-flex align-center justify-content-between">
												<router-link tag="a" to="/checkout" class="mt-2 mr-2">
													<CartNavbar :invert="scrolled || invert" />
												</router-link>

												<b-button v-b-toggle.menu-sidebar class="btn btn-menu">
													<div class="icon-menu"></div>
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</nav>

			<div class="nav-spacer" ref="spacer" v-if="!navFixed"></div>

			<b-sidebar id="menu-sidebar" right shadow sidebar-class="sidebar-menu" no-header>
				<div class="d-flex justify-content-between">
					<div class="p-3">
						<img src="@/assets/logo.png" alt="" class="logo" />
					</div>
					<div class="btn btn-close p-3" v-b-toggle.menu-sidebar>
						<i class="icon icon-close"></i>
					</div>
				</div>

				<b-nav vertical class="mt-3">
					<b-nav-item to="/" class="btn-primary" active>Inicio </b-nav-item>
					<b-nav-item to="/campers" class="btn-primary">Campers</b-nav-item>
					<b-nav-item to="/productos" class="btn-primary">Accesorios</b-nav-item>
					<b-nav-item to="/quienes-somos" class="btn-primary">Quienes somos</b-nav-item>

					<!-- <b-nav-item to="/preguntas-frecuentes" class="btn-primary">Preguntas frecuentes </b-nav-item> -->
					<b-nav-item to="/contacto" class="btn-primary">Contacto </b-nav-item>
				</b-nav>
			</b-sidebar>
		</div>
	</div>
</template>

<script>
import CartNavbar from '@/components/ecommerce/CartNavbar'


export default {
	name: 'Navbar',
	components: { CartNavbar },
	props: {
		navFixed: {
			default: true,
		},
		withImage: {
			default: false,
		},
		transparent: {
			default: false,
		},
		invert: {
			default: false,
		},
		hideCart: {
			default: false,
		},
		hideMenu: {
			default: false,
		},
	},
	data() {
		return {
			opened: false,
			scrolled: false,
			currentRoute: null,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},
	methods: {
		onScroll(e) {
			window.top.scrollY > 10 ? (this.scrolled = true) : (this.scrolled = false)
		},
	},
	beforeMount() {
		this.currentRoute = this.$route.fullPath.replace('/' + this.$route.params.lang, '')
	},
}
</script>
<style scoped>
.nav {
}
.navbar {
	position: fixed;
	top: 0px;
	z-index: 1000;
	width: 100%;
	display: block;
	background-color: #fff;
	padding: 0px 18px;
	transition: all 0.2s ease-in-out;
	border: solid 1px rgba(255, 255, 255, 0.15);
}

.navbar .container {
	display: block;
}
.navbar .btn {
	height: 44px;
}

.nav:not(.withImage) .nav-spacer {
	width: 100%;
	height: 94px;
}
.navbar .logo {
	max-height: 64px;
	margin: 12px 12px;
}

.nav-link {
	color: #000;
	font-weight: 600;
	font-size: 16px;
	transition: all 0.2s ease-in-out;
}

.sidebar-menu .logo {
	max-height: 64px;
}

.nav /deep/ .sidebar-menu {
	background-color: #000000 !important;
	color: #fff !important;
	max-width: 480px;
	width: 60vw;
}

.nav /deep/ .sidebar-menu .nav-item {
	height: 48px;
}
.nav /deep/ .sidebar-menu .nav-item:hover {
	background: none !important;
}
.nav /deep/ .sidebar-menu .nav-link {
	padding: 0.5rem 0.75rem;
	font-weight: 500;
	color: #fff;
	font-size: 28px;
	margin-left: 18px;
}
.nav /deep/ .sidebar-menu .nav-link:hover {
	color: #fff;
}

.btn-close {
	filter: invert(1);
	width: 48px;
	height: 48px;
}

.btn-menu {
	background: none;
	border: none;
}

.icon-menu {
	width: 32px;
	height: 32px;
	background-position: center center;
	background-repeat: no-repeat;
	background-image: url('../assets/img/icon-menu.png');
	filter: brightness(0);
}

@media (max-width: 991px) {
	.navbar {
		padding: 0px;
	}
	.navbar .container {
		padding: 0px;
	}
	.navbar .btn {
		padding: 0.375rem 1.1rem;
	}
	.navbar .logo {
		max-height: 48px;
	}

	.nav /deep/ .sidebar-menu .nav-link {
		font-size: 18px;
	}

	.nav-spacer {
		height: 72px;
	}
}

.nav.withImage:not(.scrolled) .navbar,
.nav.transparent:not(.scrolled) .navbar {
	background-color: transparent !important;
}

/** muestro y oculto logos */
.nav .logo-light {
	display: none;
}
.nav.transparent:not(.scrolled):not(.nav-invert) .logo-light {
	display: block;
}
.nav.transparent:not(.scrolled):not(.nav-invert) .logo-dark {
	display: none;
}

.nav.transparent.scrolled .logo-dark {
	display: block;
}
.nav.withImage .logo-light {
	display: none !important;
}
.nav.withImage .logo-dark {
	display: block !important;
}

.nav.transparent:not(.scrolled):not(.withImage):not(.nav-invert) .navbar /deep/ .nav-link {
	color: #fff !important;
	/* text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.68); */
}

.nav.transparent:not(.scrolled):not(.nav-invert) .navbar .icon-menu {
	filter: brightness(0) invert(1);
}
</style>
